import { ApiMethodType } from '@celito.clients/enums';
import { performRequest } from '@celito.clients/network';
import { WorkflowControlsDefinition } from '@celito.clients/types';

export const executeAction = async (
  actionName: string,
  recordName: string,
  recordVersion: string | null | undefined,
  payload: object
) => {
  // Build query parameters conditionally
  const queryParams = new URLSearchParams({ record_name: recordName });
  if (recordVersion) {
    queryParams.append('version', recordVersion);
  }

  const response = await performRequest<{
    actions: WorkflowControlsDefinition[];
  }>(
    `/actions/execute/${actionName}?${queryParams.toString()}`,
    ApiMethodType.POST,
    payload
  );
  return response;
};
